export const FormCheckButton: React.FC<
  React.InputHTMLAttributes<HTMLInputElement>
> = (props) => (
  <input
    {...props}
    type="checkbox"
    className="relative size-6 appearance-none align-middle outline-hidden before:absolute before:size-full before:rounded-1 before:border-2 before:border-main-80 before:content-[''] after:absolute after:inset-0 after:m-auto after:block after:h-2  after:w-1 after:rotate-45 after:content-[''] checked:before:bg-accent-primary checked:after:border-b-2 checked:after:border-r-2 checked:after:border-base-100"
  />
);
